import styled from 'styled-components';

export const Container = styled.div`
  .stars .icon {
    width: 0.7rem;
    height: 0.7rem;

    &.regHalfStar-icon {
      width: 0.8rem;
      height: 0.8rem;
    }
  }

  span {
    font-style: italic;
    text-decoration: underline;
  }
`;
